export default __webpack_public_path__ + "static/media/IMG_3699.815070c2.JPG";